import styled from 'styled-components';
import { Insurance } from '@lt/components/icons-react';
import { Meal, Plane, Bus } from '@lt/components/icons-react/userflow';
import { Link } from '@lt/components';

export const StyledMeal = styled(Meal)`
  height: 14px;
  * {
    stroke: #4d4d4d;
  }
`;

export const StyledPlane = styled(Plane)`
  width: 18px;
  stroke: #4d4d4d;
`;

export const StyledBus = styled(Bus)`
  width: 18px;
  stroke: #4d4d4d;
`;

export const StyledInsurance = styled(Insurance)`
  width: 18px;
  * {
    stroke: #4d4d4d;
  }
`;

export const Wrapper = styled.div``;
export const Title = styled.div`
  margin-bottom: 8px;
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.75em;
  line-height: 0.875em;

  letter-spacing: 0.1em;
  text-transform: uppercase;

  color: #17181a;
`;

export const RoomPreviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 8px;
`;
export const RoomPreviewImgWrapper = styled.div`
  border-radius: 50%;
  overflow: hidden;
  margin-right: 6px;
  flex-shrink: 0;
`;

export const RoomPreviewImg = styled.img`
  display: block;
  height: 30px;
  width: 30px;
`;
export const RoomPreviewDescription = styled.div`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1em;

  color: #4d4d4d;
`;

export const OptionList = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin-right: 16px;
  }
  > *:last-child {
    margin-right: 0;
  }
`;

export const StyledLink = styled<any>(Link)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
`;
